/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Injectable, OnDestroy } from '@angular/core';
import { LocalStorageHelper } from 'src/app/plain-javascript/services/LocalStorageHelper';
import { FeatureFlagObserver } from '@touchplan/feature-flags';

/**
 * FeatureFlagManager retrieves the flags from firebase, also updates/stores the values in LocalStorage
 */
@Injectable()
export class FeatureFlagManager extends FeatureFlagObserver implements OnDestroy {
	protected override writeLocally(key: string, data: any) {
		LocalStorageHelper.write(key, data);
	}

	protected override readLocally(key: string) {
		return LocalStorageHelper.read(key);
	}

	public ngOnDestroy() {
		this.destroy();
	}
}
